import axios from 'axios';
export const getDepartment = () => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL + `department/company-department`
  );
}
export const AddDepartment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `department/company-department/create`,
    obj,
    { headers }
  );
}

export const EditDepartment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `department/company-department/update`,
    obj,
    { headers }
  );
}
export const DeleteDepartment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `department/company-department/delete`,
    obj,
    { headers }
  );
}